require('smoothscroll-polyfill').polyfill();
import { throttle } from '../utils.js'

export default class Portfolio {
	constructor() {
		this.portfolio_nav = document.getElementById( 'portfolio-nav' );
		// Only continue if the portfolio-nav exists (a.k.a we're not on the home page )
		if ( this.portfolio_nav !== null ) {
			this.header = document.getElementById( 'intro' );
			this.getHeaderHeight();
			this.lastScroll = 0;
			this.animating = false;

			this.onPageLoad = this.onPageLoad.bind( this );
			this.scrollHandler = this.scrollHandler.bind( this );
			this.setHeaderOpacity = this.setHeaderOpacity.bind( this );

			// Trigger animation once page has loaded.
			document.addEventListener( 'DOMContentLoaded', this.onPageLoad );
			document.addEventListener( 'scroll', throttle( this.scrollHandler, 33 ) );
		}
	}

	getHeaderHeight() {
		this.header_height = this.header.offsetHeight;
	}

	setHeaderOpacity() {
		//Using Math.round because while more elegant toFixed() is slower
		this.header.style.opacity = 1 - ( Math.round( ( this.lastScroll / this.header_height ) * 10 ) / 10 );

		this.animating = false;
	}

	getAnimation() {
		if ( ! this.animating ) {
			requestAnimationFrame( this.setHeaderOpacity );
		}

		this.animating = true;
	}

	scrollHandler() {
		if ( this.header_height > window.pageYOffset ) {
			this.lastScroll = window.pageYOffset;

			this.getAnimation();
		}
	}

	onPageLoad() {
		setTimeout( 
			window.scrollTo( {
				top: this.header_height,
				left: 0,
				behavior: 'smooth'
			} ),
		300 );
	}
}
new Portfolio();


// WEBPACK FOOTER //
// ./js/modules/Portfolio.js